function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var EXIF = {};

EXIF.ExifMap = function () {
  return this;
};

EXIF.ExifMap.prototype.map = {
  Orientation: 0x0112
};

EXIF.ExifMap.prototype.get = function (id) {
  return this[id] || this[this.map[id]];
};

EXIF.exifTagTypes = {
  1: {
    getValue: function getValue(dataView, dataOffset) {
      return dataView.getUint8(dataOffset);
    },
    size: 1
  },
  2: {
    getValue: function getValue(dataView, dataOffset) {
      return String.fromCharCode(dataView.getUint8(dataOffset));
    },
    size: 1,
    ascii: true
  },
  3: {
    getValue: function getValue(dataView, dataOffset, littleEndian) {
      return dataView.getUint16(dataOffset, littleEndian);
    },
    size: 2
  },
  4: {
    getValue: function getValue(dataView, dataOffset, littleEndian) {
      return dataView.getUint32(dataOffset, littleEndian);
    },
    size: 4
  },
  5: {
    getValue: function getValue(dataView, dataOffset, littleEndian) {
      return dataView.getUint32(dataOffset, littleEndian) / dataView.getUint32(dataOffset + 4, littleEndian);
    },
    size: 8
  },
  9: {
    getValue: function getValue(dataView, dataOffset, littleEndian) {
      return dataView.getInt32(dataOffset, littleEndian);
    },
    size: 4
  },
  10: {
    getValue: function getValue(dataView, dataOffset, littleEndian) {
      return dataView.getInt32(dataOffset, littleEndian) / dataView.getInt32(dataOffset + 4, littleEndian);
    },
    size: 8
  }
};
EXIF.exifTagTypes[7] = EXIF.exifTagTypes[1];

EXIF.getExifValue = function (dataView, tiffOffset, offset, type, length, littleEndian) {
  var tagType = EXIF.exifTagTypes[type];

  if (!tagType) {
    return;
  }

  var tagSize = tagType.size * length;
  var dataOffset = tagSize > 4 ? tiffOffset + dataView.getUint32(offset + 8, littleEndian) : offset + 8;

  if (dataOffset + tagSize > dataView.byteLength) {
    return;
  }

  if (length === 1) {
    return tagType.getValue(dataView, dataOffset, littleEndian);
  }

  var values = [];

  for (var i = 0; i < length; i += 1) {
    values[i] = tagType.getValue(dataView, dataOffset + i * tagType.size, littleEndian);
  }

  if (tagType.ascii) {
    var str = '';

    var _iterator = _createForOfIteratorHelper(values),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var c = _step.value;

        if (c === "\0") {
          break;
        }

        str += c;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return str;
  }

  return values;
};

EXIF.parseExifTag = function (dataView, tiffOffset, offset, littleEndian, data) {
  var tag = dataView.getUint16(offset, littleEndian);
  data.exif[tag] = EXIF.getExifValue(dataView, tiffOffset, offset, dataView.getUint16(offset + 2, littleEndian), dataView.getUint32(offset + 4, littleEndian), littleEndian);
};

EXIF.parseExifTags = function (dataView, tiffOffset, dirOffset, littleEndian, data) {
  if (dirOffset + 6 > dataView.byteLength) {
    return;
  }

  var tagsNumber = dataView.getUint16(dirOffset, littleEndian);
  var dirEndOffset = dirOffset + 2 + 12 * tagsNumber;

  if (dirEndOffset + 4 > dataView.byteLength) {
    return;
  }

  for (var i = 0; i < tagsNumber; i += 1) {
    this.parseExifTag(dataView, tiffOffset, dirOffset + 2 + 12 * i, littleEndian, data);
  }

  return dataView.getUint32(dirEndOffset, littleEndian);
};

EXIF.parseExifData = function (dataView, offset, length, data) {
  var tiffOffset = offset + 10;
  var littleEndian;
  var dirOffset;

  if (dataView.getUint32(offset + 4) !== 0x45786966) {
    return;
  }

  if (tiffOffset + 8 > dataView.byteLength) {
    return;
  }

  if (dataView.getUint16(offset + 8) !== 0x0000) {
    return;
  }

  switch (dataView.getUint16(tiffOffset)) {
    case 0x4949:
      littleEndian = true;
      break;

    case 0x4d4d:
      littleEndian = false;
      break;

    default:
      return;
  }

  if (dataView.getUint16(tiffOffset + 2, littleEndian) !== 0x002a) {
    return;
  }

  dirOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
  data.exif = new EXIF.ExifMap();
  EXIF.parseExifTags(dataView, tiffOffset, tiffOffset + dirOffset, littleEndian, data);
};

export default EXIF;